import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';

import getEnvConfig from '../../../../../utils/config/env';
import { BotProps, WelcomeMessageProps } from './bot.interface';

export const botApi = createApi({
    reducerPath: 'botAi',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem('accessToken');
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['BOT'],

    endpoints: builder => ({
        createBot: builder.mutation<any, any>({
            query: payload => ({
                url: `/shops/bot/${payload.shop_id}`,
                method: 'POST',
                body: { ...payload },
            }),
            invalidatesTags: ['BOT'],
        }),

        readBot: builder.query<BotProps, number>({
            query: id => {
                return {
                    url: `/shops/bot/${id}`,
                };
            },
            transformResponse: (res: { data: BotProps }) => {
                return res.data;
            },
        }),

        createWelcomeMessage: builder.mutation<
            { id: number },
            { id: number; body: FormData }
        >({
            query: ({ id, body }) => ({
                url: `/shops/bot/settings/${id}`,
                method: 'POST',
                body: body,
            }),
            invalidatesTags: ['BOT'],
        }),

        readWelcomeMessage: builder.query<WelcomeMessageProps, number>({
            query: id => {
                return {
                    url: `/shops/bot/settings/${id}`,
                };
            },
            transformResponse: (res: { data: WelcomeMessageProps }) => {
                return res.data;
            },
        }),
    }),
});

export const {
    useCreateBotMutation,
    useReadBotQuery,
    useCreateWelcomeMessageMutation,
    useReadWelcomeMessageQuery,
} = botApi;
